import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { ProductStore } from '../../../core/models/interfaces-general';
import { ProductCardStoreComponent } from './product-card-store.component';

export type SortOption = 'default' | 'popular' | 'rating' | 'recent' | 'price-asc' | 'price-desc';

@Component({
  selector: 'app-product-grid-section',
  standalone: true,
  imports: [CommonModule, FormsModule, ProductCardStoreComponent],
  template: `
    <section class="max-w-7xl mx-auto px-4 sm:px-6 md:px-12 py-6">
      
      <!-- BARRA SUPERIOR DE CONTROLES (RESPONSIVA) -->
      <div class="flex flex-col sm:flex-row sm:items-center justify-between gap-4 mb-6 text-sm text-gray-600">
        
        <!-- INDICADOR DE RESULTADOS -->
        <div>
          Mostrando 
          <span class="font-bold text-gray-900">
            1-{{ displayedProducts.length }}
          </span> 
          de 
          <span class="font-bold text-gray-900">
            {{ total || products.length }}
          </span> 
          resultados
        </div>

        <!-- SELECTORES (MOSTRAR X & ORDENAR) -->
        <div class="flex flex-wrap items-center gap-3">
          
          <!-- SELECTOR DE CANTIDAD A MOSTRAR -->
          <div class="flex items-center gap-2 bg-gray-100/80 px-3 py-1.5 rounded-full border border-gray-200/60">
            <span class="text-xs font-semibold text-gray-500">Mostrar</span>
            <select 
              [(ngModel)]="itemsPerPage" 
              (change)="emitPageSize()"
              class="bg-transparent font-bold text-rose-500 focus:outline-none cursor-pointer text-sm"
            >
              <option [ngValue]="6">6</option>
              <option [ngValue]="9">9</option>
              <option [ngValue]="12">12</option>
              <option [ngValue]="18">18</option>
            </select>
          </div>

          <!-- SELECTOR DE ORDENAMIENTO -->
          <div class="relative">
            <select 
              [(ngModel)]="currentSort" 
              (change)="emitSort()"
              class="w-full sm:w-auto bg-white border border-gray-200 rounded-full px-4 py-2 font-medium text-gray-700 shadow-sm focus:outline-none focus:ring-2 focus:ring-rose-400 cursor-pointer appearance-none pr-8 text-sm"
            >
              <option value="default">Orden predeterminado</option>
              <option value="popular">Más populares</option>
              <option value="rating">Mejor valorados</option>
              <option value="recent">Más recientes</option>
              <option value="price-asc">Precio: bajo a alto</option>
              <option value="price-desc">Precio: alto a bajo</option>
            </select>
            <!-- FLECHA SVG DEL SELECT -->
            <div class="absolute right-3 top-1/2 -translate-y-1/2 pointer-events-none text-gray-500">
              <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7" />
              </svg>
            </div>
          </div>

        </div>

      </div>

      <!-- GRILLA DE PRODUCTOS -->
      <div class="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6 md:gap-8">
        <app-product-card-store
          *ngFor="let item of displayedProducts" 
          [product]="item"
        ></app-product-card-store>
      </div>

    </section>
  `
})
export class ProductGridSectionComponent implements OnInit, OnChanges {
  @Input({ required: true }) products: ProductStore[] = [];
  @Input() total = 0;
  @Output() sortChange = new EventEmitter<SortOption>();
  @Output() pageSizeChange = new EventEmitter<number>();

  itemsPerPage: number = 9;
  currentSort: SortOption = 'default';
  displayedProducts: ProductStore[] = [];

  ngOnInit() {
    this.displayedProducts = this.products;
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['products']) {
      this.displayedProducts = this.products;
    }
  }

  emitSort() {
    this.sortChange.emit(this.currentSort);
  }

  emitPageSize() {
    this.pageSizeChange.emit(this.itemsPerPage);
  }
}